import { Button, StapleTableBody, StapleTableHeading } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TableInfoSectionStyled = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const DateTableHeadingStyled = styled(StapleTableHeading)`
  text-align: right;
`;

export const StapleTableBodyStyled = styled(StapleTableBody)`
  min-height: 35rem;
`;

export const TotalFilesTextStyled = styled.p`
  font-size: 1.6rem;
  line-height: 1.8rem;
  margin: 0 0 2rem;
`;

export const FileIndexStyled = styled.b`
  margin-right: 0.5rem;
`;

export const FilesCountStyled = styled.b`
  margin-left: 0.5rem;
`;

export const DownloadButtonWrapper = styled.div`
  display: flex;
  justify-self: flex-end;
`;

export const TriggerButtonStyled = styled(Button)`
  margin: 0 auto 5rem;
`;
